import { cloneDeep } from "lodash";

export const trimText = (text, max) => {
    const clonedText = cloneDeep(text);
    const cutText = clonedText.length > max
        ? clonedText.slice(0, (max - 3)) + '...' :
        clonedText;
    return cutText;
};
